import React from 'react';
import './key-value-pair.scss';
import { View, Text } from '../../common';

interface KeyValuePairProps {
  title: string;
  value: string;
  className?: string;
}

export const KeyValuePair: React.FC<KeyValuePairProps> = ({
  title,
  value,
  className = '',
}) => {
  return (
    <View className={`key-value-pair ${className}`}>
      <Text className="key-value-pair-title font-medium">{title}</Text>
      <Text className="key-value-pair-value font-medium">{value}</Text>
    </View>
  );
};
